import React from "react";
import { motion } from "framer-motion";
import {
  FaClipboardList,
  FaCreditCard,
  FaClock,
  FaExclamationTriangle,
} from "react-icons/fa";
import {
  EMERGENCY_PHONE_DISPLAY,
  EMERGENCY_PHONE_TEL,
} from "../../utils/clinicContact";
import "./PatientInfo.css";

const PatientInfo = () => {
  return (
    <div className="patient-info-page">
      <section className="patient-info-hero">
        <div className="container">
          <motion.div
            className="patient-info-hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 style={{ fontSize: "1.8rem" }}>Patient Information</h1>
            <p style={{ fontSize: "var(--font-size-base)" }}>
              Everything you need to know before your appointment
            </p>
          </motion.div>
        </div>
      </section>

      <div className="container">
        <div className="patient-info-content">
          <motion.div
            className="info-section"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2>Preparing for Your Appointment</h2>
            <div className="preparation-list">
              <div className="prep-item">
                <FaClipboardList />
                <div>
                  <h3>Bring Required Documents</h3>
                  <ul>
                    <li>Photo ID</li>
                    <li>Previous medical records</li>
                    <li>List of current medications</li>
                    <li>Insurance card (optional)</li>
                  </ul>
                </div>
              </div>

              <div className="prep-item">
                <FaClock />
                <div>
                  <h3>Arrive Early</h3>
                  <p>
                    Please arrive 15 minutes before your scheduled appointment
                    time to complete paperwork.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            className="info-section"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h2>Payment & Insurance</h2>
            <div className="payment-info">
              <div className="payment-item">
                <FaCreditCard />
                <div>
                  <h3>Accepted Payment Methods</h3>
                  <ul>
                    <li>Cash</li>
                    <li>Credit/Debit Cards</li>
                    <li>Insurance</li>
                  </ul>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            className="info-section"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <h2>Emergency Contact</h2>
            <div className="emergency-info">
              <div className="emergency-item">
                <FaExclamationTriangle />
                <div>
                  <h3>24/7 Emergency Care</h3>
                  <p>For cardiac emergencies, call us immediately:</p>
                  <a href={`tel:${EMERGENCY_PHONE_TEL}`} className="emergency-phone">
                    {EMERGENCY_PHONE_DISPLAY}
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default PatientInfo;
